import { Modal as AntdModal } from "antd"
import PropTypes from "prop-types"
import * as css from "./Modal.module.css"

function Modal({ children, className, onClose, open = true, size, ...rest }) {
  const widthMap = { tiny: 400, small: 560, large: 900 }
  const width = widthMap[size] || 600

  return (
    <AntdModal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={width}
      className={className}
      destroyOnClose
      {...rest}
    >
      <div className={css.content}>{children}</div>
    </AntdModal>
  )
}

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  open: PropTypes.bool,
  size: PropTypes.oneOf(["mini", "tiny", "small", "large", "fullscreen"]),
}

export default Modal
